var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFive9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Logo",
    viewBox: "357.5 339.67 1205 400.67",
    width: "100px",
    height: "53px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a4cf9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1425.6,339.67c-73.75,0-137.45,54.64-137.45,131.34,0,82.79,64.81,125.28,122.37,125.28,8.38,0,17.87-1.66,23.46-4.42l2.23,2.2-85.49,139.06h85.5l106.17-188.17c11.73-21.53,20.11-46.36,20.11-73.95,0-77.82-63.15-131.34-136.9-131.34ZM1425.62,533.92c-36.89,0-62.59-28.14-62.59-62.91s25.72-62.36,62.59-62.36,62.58,27.04,62.58,62.36-25.68,62.91-62.58,62.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 615.32,
    y: 442.89,
    width: 72.64,
    height: 290.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "925.06 442.89 855.78 647.62 851.3 647.62 781.45 442.89 705.46 442.89 812.76 733.17 894.89 733.17 1002.74 442.89 925.06 442.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1136.59,435.71c-86.05,0-148.07,62.36-148.07,153.97,0,86.65,61.46,150.66,148.07,150.66,75.99,0,128.52-38.65,143.04-97.69h-67.61c-10.05,23.74-37.43,40.29-73.19,40.29-46.94,0-77.67-29.8-79.91-73.95h223.51v-22.62c0-81.68-51.4-150.66-145.84-150.66ZM1060.04,558.23c4.48-36.43,34.1-65.12,76.56-65.12s73.19,25.95,76.54,65.12h-153.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "357.5 733.17 431.82 733.17 431.82 576.44 582.69 576.44 582.69 513.53 431.82 513.53 431.82 410.33 597.21 410.33 597.21 346.86 357.5 346.86 357.5 733.17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1490.33,713.44c0-13.89,9.96-25.08,25.08-25.08s25.57,11.07,25.57,24.96-9.71,25.08-25.33,25.08-25.33-11.07-25.33-24.96ZM1536.56,713.32c0-11.8-7.87-20.78-21.15-20.78s-20.66,9.1-20.66,20.9,7.87,20.9,20.9,20.9,20.9-9.1,20.9-21.02ZM1507.05,700.16h9.96c5.78,0,9.22,3.81,9.22,8.36,0,3.81-2.09,6.64-4.67,7.62l5.53,10.57h-4.8l-4.8-9.59h-5.9v9.59h-4.55v-26.56ZM1516.64,713.19c3.07,0,4.8-2.09,4.8-4.55,0-2.58-1.84-4.55-4.8-4.55h-5.04v9.1h5.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive9);
export default __webpack_public_path__ + "static/media/five9.d213d1b060c9eeec8e03931c0e4b5a89.svg";
export { ForwardRef as ReactComponent };